import heading from 'text!./templates/Heading.html';

export default [() => ({
    restrict: 'E',
    replace: true,
    transclude: true,
    template: heading,
    scope: {}
})];